<h1 mat-dialog-title>{{ !!data ? 'Edit Portfolio' : 'Add Portfolio' }}</h1>
<div mat-dialog-content>
  <form [formGroup]="portfolioData" class="dense-1">
    <div class="row pb-1">
      <mat-form-field>
        <mat-label>Name</mat-label>
        <input matInput formControlName="name" type="text">
        <mat-error>@if (portfolioData.controls['name'].errors?.['required']) { Name is required. }</mat-error>
      </mat-form-field>
    </div>

    <div class="row pb-1">
      <mat-form-field>
        <mat-label>Description</mat-label>
        <textarea matInput formControlName="description" type="text" maxlength="255" rows="3"></textarea>
      </mat-form-field>
    </div>

    <div class="row pb-1">
      <mat-form-field>
        <mat-label>
          Projects {{portfolioData.controls['selectedProjects'].value?.length === 0
          ? ""
          : "(" + portfolioData.controls['selectedProjects'].value.length + ' selected)'}}
        </mat-label>
        <mat-chip-grid #chipGrid formControlName="selectedProjects">
          @for (projectId of portfolioData.controls['selectedProjects']?.value; track projectId) {
            <mat-chip-row [value]="projectId" (removed)="removeProject(projectId)">
              {{ this.projectMap.get(projectId)?.proj_full_name ?? ''}}
              <button matChipRemove>
                <mat-icon>cancel</mat-icon>
              </button>
            </mat-chip-row>
          }
        </mat-chip-grid>
        <input #projectInput type="text" matInput [matAutocomplete]="auto" [matChipInputFor]="chipGrid" formControlName="project">
        <mat-autocomplete #auto="matAutocomplete" (optionSelected)="addProject($event)">
          @for (proj of filteredProjectList | async; track proj.proj_id) {
            <mat-option [value]="proj">{{ proj.proj_full_name }}</mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>
    </div>

    <div class="row">
      <mat-form-field>
        <mat-label>Portfolio Company</mat-label>
        <mat-select formControlName="projectLogo">
          <mat-option [value]="undefined"></mat-option>
          @for (company of companyList; track $index) {
            <mat-option [value]="company.id">{{ company.display_name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  </form>
</div>
<div mat-dialog-actions>
  <button matButton="outlined" (click)="close()">Close</button>
  <button matButton="filled" [disabled]="!portfolioData.dirty || portfolioData.invalid" (click)="createPortfolio()">Submit</button>
</div>
